import React from 'react';
import { Layout } from 'features/common/components/Layout';
import { TransactionLookup as TransactionLookupComponent } from 'features/transaction-lookup/components/TransactionLookup';

const TransactionLookup = (): JSX.Element => {
	return (
		<Layout>
			<TransactionLookupComponent />
		</Layout>
	);
};

export default TransactionLookup;
